export default __webpack_public_path__ + "static/logo-large-winter-e4104fd3a8f3468f5d18cbd2ac573bdb.svg";